export const TOP_NAVIGATION_HEIGHT = 64;
